/* @ngInject */
const mySaleSearchForm = (
  $$sale,
  toaster
) => {
  return {
    restrict: 'E',
    scope: {
      searchedSales: '=mySearchedSales',
    },
    template: require('./mySaleSearchForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.searchdata = $$sale.search
      $scope.fieldsOptions = $$sale.metadata.fields

      $scope.searchSales = async (_searchdata) => {
        try {
          const response = await $$sale.request.getBySearch(_searchdata)
          $scope.searchedSales = response.sales
          toaster.message(response.message, response.color)
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reset = () => {
        $scope.searchdata = $$sale.search
        $scope.searchdata.wagonIds.splice(0, $scope.searchdata.wagonIds.length)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default mySaleSearchForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/directives/forms/mySaleSearchForm.js